var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',[_c('h1',[_vm._v("Unauthorized")]),_vm._v(" You are not authorized to view this resource. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }